<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{$t('用户ID')}}<template slot="title">{{$t('用户ID')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="realName" >
        <span slot="label" ><a-tooltip>{{$t('姓名')}}<template slot="title">{{$t('姓名')}}</template></a-tooltip> </span>
        <a-input v-model="form.realName" :maxLength="32" :placeholder="$t('请输入')+'姓名'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="mobile" >
        <span slot="label" ><a-tooltip>{{$t('手机号')}}<template slot="title">{{$t('手机号')}}</template></a-tooltip> </span>
        <a-input v-model="form.mobile" :maxLength="30" :placeholder="$t('请输入')+'手机号'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="areapId" >
        <span slot="label" ><a-tooltip>{{$t('省市区地区信息id(省份)外键{extra_area.area_id}')}}<template slot="title">{{$t('省市区地区信息id(省份)外键{extra_area.area_id}')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.areapId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'省市区地区信息id(省份)外键{extra_area.area_id}'" />
      </a-form-model-item>
      <a-form-model-item prop="areacId" >
        <span slot="label" ><a-tooltip>{{$t('省市区地区信息id(城市)外键{extra_area.area_id}')}}<template slot="title">{{$t('省市区地区信息id(城市)外键{extra_area.area_id}')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.areacId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'省市区地区信息id(城市)外键{extra_area.area_id}'" />
      </a-form-model-item>
      <a-form-model-item prop="areaxId" >
        <span slot="label" ><a-tooltip>{{$t('省市区地区信息id(地区)外键{extra_area.area_id}')}}<template slot="title">{{$t('省市区地区信息id(地区)外键{extra_area.area_id}')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.areaxId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'省市区地区信息id(地区)外键{extra_area.area_id}'" />
      </a-form-model-item>
      <a-form-model-item prop="address" >
        <span slot="label" ><a-tooltip>{{$t('详细地址')}}<template slot="title">{{$t('详细地址')}}</template></a-tooltip> </span>
        <a-input v-model="form.address" :maxLength="300" :placeholder="$t('请输入')+'详细地址'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('状态 0待拨打 1已拨打')}}<template slot="title">{{$t('状态 0待拨打 1已拨打')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{$t('自我优势')}}<template slot="title">{{$t('自我优势')}}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCooperation, addCooperation, updateCooperation } from '@/api/user/cooperation'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        realName: null,
        mobile: null,
        areapId: null,
        areacId: null,
        areaxId: null,
        address: null,
        status: 0,
        remark: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          userId: [{ required: true, message: this.$t('用户ID')+this.$t('不能为空'), trigger: 'blur' }] ,
          areapId: [{ required: true, message: this.$t('省市区地区信息id(省份)外键{extra_area.area_id}')+this.$t('不能为空'), trigger: 'blur' }] ,
          areacId: [{ required: true, message: this.$t('省市区地区信息id(城市)外键{extra_area.area_id}')+this.$t('不能为空'), trigger: 'blur' }] ,
          areaxId: [{ required: true, message: this.$t('省市区地区信息id(地区)外键{extra_area.area_id}')+this.$t('不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        realName: null,
        mobile: null,
        areapId: null,
        areacId: null,
        areaxId: null,
        address: null,
        status: 0,
        remark: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCooperation({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCooperation(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCooperation(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
